"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M41.3 9.834L38.33 7.52a1 1 0 0 0-1.4.175l-17.697 22.73-8.613-8.614a1 1 0 0 0-1.414 0l-2.695 2.695a1 1 0 0 0 0 1.414l12.432 12.447a1 1 0 0 0 1.5-.093l21.034-27.037a1 1 0 0 0-.177-1.403z" })
);

